import { z } from 'zod';

export const attachmentsSchema = z.object({
  data: z.object({
    attachments: z.array(
      z.object({
        id: z.number(),
        name: z.string(),
      })
    ),
  }),
});

export type AttachmentsSchema = z.infer<typeof attachmentsSchema>;
